'use client';

import type { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { Banner } from '~/components/commons/Banner/Banner';
import { MainColumn } from '~/components/commons/MainColumn/MainColumn';

export const CompleteProfileBannerWrapper = ({
  children,
  isHomepage,
}: PropsWithChildren<{
  isHomepage?: boolean;
}>) => {
  const t = useTranslations('HOMEPAGE.COMPLETE_PROFILE');

  return (
    <MainColumn>
      <div
        data-testid="completeProfile"
        className={classNames('complete-profile complete-profile--banner', {
          'complete-profile--not-homepage': !isHomepage,
        })}
      >
        <Banner
          title={t('TITLE')}
          description={t('DESCRIPTION')}
        >
          {children}
        </Banner>
      </div>
    </MainColumn>
  );
};
